/*
 * globo-search-click-guard.js
 * Hace que los resultados del buscador de Globo se puedan clickear.
 *
 * Por qué: el popup de resultados de Globo (.glFilter-search-popup / .ui-autocomplete)
 * se cierra con el focusout del input de busqueda SIN protegerse del mousedown
 * dentro del propio popup. Secuencia medida en produccion (2026-07-30, desktop):
 *   t+0ms  mousedown sobre el <a> del resultado (popup visible)
 *   t+23ms focusout del input -> Globo cierra el popup (display:none)
 *   t+24ms mouseup y click caen en lo que quedo ATRAS del popup
 * Consecuencia para el usuario: el click "cierra la ventana" y no navega, o peor,
 * navega a OTRO producto (la card del carrusel de la home que quedo debajo).
 * Reproducido: click en KART RAGNO -> aterrizaba en PROTO GT.
 *
 * Que hace: en mousedown capturado, si el target esta dentro del popup de Globo,
 * previene el default (el cambio de foco). El input no pierde el foco, Globo no
 * cierra el popup, y el click llega entero al <a> del resultado. preventDefault
 * en mousedown NO bloquea el click posterior.
 *
 * Excepcion: los inputs propios del popup (el overlay fullscreen de mobile trae
 * su propio buscador #gl-d-searchbox-input) SI necesitan tomar foco: se dejan pasar.
 *
 * Verificado en vivo inyectando este mismo listener: el mismo click que moria en
 * el <body> paso a navegar a /products/volante-kart-evo.
 *
 * Nota: el fix de fondo es de Globo (reportar). Esto es un workaround del theme
 * que no toca codigo de la app: si Globo lo arregla, este guard queda inocuo.
 */
(function () {
  'use strict';

  if (window.__collinoSearchGuard) return;
  window.__collinoSearchGuard = true;

  // Overlay keyboard/focus lifecycle is coordinated by navigation-panels.js.
  document.addEventListener('mousedown', function (e) {
    if (!e.target || !e.target.closest) return;

    var popup = e.target.closest('.glFilter-search-popup, .ui-autocomplete');
    if (!popup) return;

    // Campos dentro del popup (buscador del overlay mobile de Globo) necesitan foco.
    if (e.target.closest('input, textarea, select, [contenteditable]')) return;

    e.preventDefault();
  }, true);
})();
